import SmallText from "@/components/ui/SmallText";
import { Button } from "@/components/ui/button";
import { CloseCampaignDialog } from "./components/CloseCampaignDialog";
import { capitalizeAndSplit, parseZFormatDate } from "@/utils/Functions/Functions";
import { useGetUserHiringresource, useGetUserHiringresourceAccount, usePutHiringcampaignsId } from "../../../openapi/api/endpoints/default/default";
import { useQueryClient } from "@tanstack/react-query";
import { HiringCampaign, WorkAuthorizationAcceptedStatuses } from "openapi/api/model";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { HiringCampaignFormSchema } from "@/utils/FormUtils/FormSchema";
import { HiringCampaignFormValues } from "../HiringCampaign/components/editHiringCampaignForm";
import { Form } from "@/components/ui/form";
import { EndOfCampaignDate, StartOfCampaignDate } from "../HiringCampaign/components/CampaignPeriodInputs";
import ProjectDescriptionInput from "../HiringCampaign/components/ProjectDescriptionInput";
import ExperienceLevelSelector from "../HiringCampaign/components/ExperienceLevelSelector";
import { CompanyNameInput } from "../HiringCampaign/components/CompanyNameInput";
import { useEffect } from "react";
//import { FormSkillsCheckbox } from "./utils/SkillsCheckbox";
import { PositionInput } from "../HiringCampaign/components/PositionInput";
import { EmploymentTypeInput } from "../HiringCampaign/components/EmploymentTypeInput";
import { LocationInput } from "../HiringCampaign/components/LocationInput";
import { Progress } from "@/components/ui/progress";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Layers, Stamp } from "lucide-react";
import { InstantMatchButton } from "../HiringCampaign/components/InstantMatchButton";

export type CampaignDetailsProps = {
  hcID: string;
  companyName?: string;
  status?: "Draft" | "Closed" | "In Progress" | "Complete" | string;
  //daysLive?: number,
  daysLeft?: number;
  hiringDetail: HiringCampaign
};

const CampaignDetails = ({
  hcID,
  companyName,
  status,
  //daysLive,
  daysLeft,
  hiringDetail
}: CampaignDetailsProps) => {
  const { data } = useGetUserHiringresource();
  const { data:users } = useGetUserHiringresourceAccount()
  const write = users?.find((user)=>user.user?._id===data?._id)?.permissions[0].permissions.write

  //const userData = data as HrUser;
  const queryClient = useQueryClient()

  //const detail = HCdetail as CampaignDetailResponse;
  console.log('Campaign Detail: ',hiringDetail)
  const mainSkills = hiringDetail?.mainSkills??[];
  const acceptedStatuses = hiringDetail?.workAuthorization?.acceptedStatuses??[];
  const niceToHaveSkills = hiringDetail?.niceToHaveSkills??[];
  const problemSpaces = hiringDetail?.problemSpaces??[];
  const mustHave = hiringDetail?.qualifications?.mustHave??[];
  const niceToHave = hiringDetail?.qualifications?.niceToHave??[];
  const requiresCitizenshipForClearance = hiringDetail?.workAuthorization?.requiresCitizenshipForClearance??false;
  const requiresSecurityClearance = hiringDetail?.workAuthorization?.requiresSecurityClearance??false;
  const requiresSponsorship = hiringDetail?.workAuthorization?.requiresSponsorship??false;
  const role = hiringDetail?.role??{}
 
  const form = useForm<HiringCampaignFormValues>({
    /* defaultValues: {
      //position: detail?.position??'',
      positionDescription: detail.positionDescription??'',
      companyName: companyName??'',
      experienceLevel: detail.experienceLevel??'',
      skills: detail.skills??[''],
      startOfCampaignDate: parseZFormatDate(detail?.startDate),
      endOfCampaignDate: parseZFormatDate(detail?.endDate), 
    }, */
    resolver: zodResolver(HiringCampaignFormSchema),
  });

  const renderAcceptedStatuses = (
    statuses: WorkAuthorizationAcceptedStatuses
  ): string[] => {
    if (typeof statuses === "string") {
      // If it's a simple string like "Any legal work authorization"
      return [statuses];
    } else {
      // If it's an object, extract relevant information
      const canadaStatuses = statuses.Canada || [];
      const usStatuses = statuses.US || [];
      const otherStatus = statuses.Other ? [statuses.Other] : [];
  
      return [...canadaStatuses, ...usStatuses, ...otherStatus];
    }
  };

  const booleanToYesOrNo = (value: boolean): string => (value ? "Yes" : "No");

  const { mutate, error } = usePutHiringcampaignsId({
    mutation: {
      onSuccess:()=>{  
        toast.success("Submitted!", {
          description: "Hiring Campaign updated successfully",
          action: {
            label: "Dismiss",
            onClick: () => {},
          },
          style: {
            background: "#a3e635",
          },
        });
      },
      onError:()=>{
        console.log("Error: ", error);
        toast.error("An error occured!", {
          description: `${error}`,
          action: {
            label: "Dismiss",
            onClick: () => {},
          },
          style: {
            background: "#dc2626",
          },
        });
      },
      onSettled:()=>{
        console.log('On settled: ',hcID)
        queryClient.invalidateQueries()
      }
    }
  });

  const onSubmit = (data: any) => {
    //console.log('sumbitted data: ',data)
    const submittedData = data as HiringCampaignFormValues;
    const startDate = submittedData?.startOfCampaignDate.toISOString(); //.split("T")[0]
    const endDate = submittedData?.endOfCampaignDate.toISOString(); //.split("T")[0]

    console.log("Submitted!!", submittedData);
    const campaignInfo: HiringCampaign = {
      position: submittedData.position,
      projectDescription: submittedData.projectDescription,
      mainSkills: submittedData.skills,
      experienceLevel: submittedData.experienceLevel,
      companyName: submittedData.companyName,
      //devlimit: 150,
      //companyId: userData.companyId as string,
      startDate: startDate,
      endDate: endDate,
      manuallyClosed: false,
      employmentType: hiringDetail.employmentType ?? "Full-time",
      licenseId: hiringDetail.licenseId ?? "",
      location: hiringDetail.location ?? "",
      niceToHaveSkills: hiringDetail.niceToHaveSkills ?? [],
      problemSpaces: hiringDetail.problemSpaces ?? [],
      qualifications: hiringDetail.qualifications ?? {
        mustHave: [],
        niceToHave: []
      },
      redFlags: hiringDetail.redFlags ?? [],
      locationFlexibility: "",
      workAuthorization: hiringDetail.workAuthorization?? {},
      role:hiringDetail.role

    };
    console.log("Payload: ", campaignInfo);
    
    mutate({id:hcID, data:campaignInfo});
    
  }

  useEffect(() => {
    if (hiringDetail) {//only rerender if these conditions are satisfied
      form.reset({
        position: hiringDetail?.position??'',
        employmentType: hiringDetail.employmentType??'',
        location: hiringDetail.location??'',
        projectDescription: hiringDetail.projectDescription??'',
        companyName: companyName??'',
        experienceLevel: hiringDetail.experienceLevel??'',
        //mainSkills: hiringDetail.mainSkills??[],
        //niceToHaveSkills: hiringDetail.niceToHaveSkills??[],
        startOfCampaignDate: parseZFormatDate(hiringDetail?.startDate),
        endOfCampaignDate: parseZFormatDate(hiringDetail?.endDate),
      });
      console.log('Form: ',form)
    }
  }, [form, hiringDetail]);
  
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-2 px-4 py-4 mx-4">
        <div className="grid grid-cols-2 pb-4 px-4 max-xl:grid-cols-1 max-xl:gap-16"> 
          <div className="grid grid-cols-3 grid-rows-2 justify-center items-center gap-8 max-xl:order-last">
            <PositionInput form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
            <CompanyNameInput form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
            <LocationInput form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
            <EmploymentTypeInput form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
            <StartOfCampaignDate form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
            <EndOfCampaignDate form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
          </div>
          <div className="relative flex flex-row pb-4 px-4 justify-end items-center space-x-4 xl:space-x-8">
          <div className="absolute top-0 right-0 flex flex-col items-end space-y-4">
            <InstantMatchButton
              jobTitle="Head of Engineering"
              requiredSkills={["React", "TypeScript", "Node.js"]}
              niceToHaveSkills={["AWS", "GraphQL", "Python"]}
              hiringCampaignId={hcID}
            />

            <div className="flex flex-row items-center space-x-8">
              <SmallText textStyle="flex text-center space-x-1">
                <p className="font-bold">Days Left:</p>
                <p>{daysLeft}</p>
              </SmallText>

              <SmallText textStyle="flex flex-row items-center text-center space-x-1">
                <p className="font-bold">Status:</p>
                <div className="flex flex-row items-center px-2 space-x-2">
                  <p>{capitalizeAndSplit(status as string)}</p>
                  <CloseCampaignDialog
                    id={hcID}
                    btn={
                      <Button className="bg-mint100 text-black hover:bg-teal100" disabled={!write}>
                        Close Campaign
                      </Button>
                    }
                  />
                </div>
              </SmallText>
            </div>
          </div>
            
          </div>  
        </div>

        <div className="flex flex-col py-0 px-4 space-y-8">
          <ProjectDescriptionInput form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
          <Card>
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2">
                Matched Roles (From provided job description)
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="mb-4 space-y-8">
                <h3 className="font-semibold">Category:{" "}
                  <span className="font-normal text-sm">{role?.classification?.category??''}</span>
                </h3>
                <div className="flex flex-wrap gap-8">
                  {role?.classification?.roles?.map((role, index) => 
                    <div>
                      <h3 key={index} className="font-semibold">
                        {role.role??''} ({(role.weight * 100).toFixed(2)}%)
                      </h3>
                      <h3 key={index} className="font-normal text-sm">
                        {role.description??''}
                      </h3>
                    </div>
                  )}
                </div>
                <h3 className="font-semibold mb-4">Explanation:{" "}
                  <span className="font-normal text-sm">{role?.classification?.why??''}</span>
                </h3>
              </div>    
            </CardContent>
          </Card>
          <div className="grid grid-cols-2 gap-10">
            {/* <div>
              <FormSkillsCheckbox form={form} disabled={form.getValues("startOfCampaignDate")<new Date()}/>
            </div> */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg flex items-center gap-2">
                  <Layers className="w-5 h-5" />Skills</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="mb-4">
                  <h3 className="font-semibold mb-2">Main Skills</h3>
                  <div className="flex flex-wrap gap-2">
                    {mainSkills.map((skill, index) => (
                      <Badge key={index} variant="secondary" className="bg-gray-200">
                        {skill}
                      </Badge>
                    ))}
                  </div>
                </div>
                  <div>
                  <h3 className="font-semibold mb-2">Nice to Have Skills</h3>
                  {niceToHaveSkills.map((skill, index) => (
                    <div key={index} className="mb-4">
                      <div className="flex justify-between mb-1">
                        <span>{skill.skill}</span>
                        <span>{(skill.weight * 100).toFixed(2)}%</span>
                      </div>
                      <Progress value={(skill.weight * 100)} 
                        className='[&>*]:bg-gray-700 h-3'
                        max={100} />
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            <div>
              <ExperienceLevelSelector 
                form={form} 
                placeholder={form.getValues("experienceLevel")}
                disabled={form.getValues("startOfCampaignDate")<new Date()}/>
              
              <Card className="mt-6">
                <CardHeader>
                  <CardTitle className="text-lg flex items-center gap-2">
                    <Stamp className="w-5 h-5" />Work Authorization</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="mb-4">
                    <h3 className="font-semibold mb-2">Accepted Status</h3>
                    <div className="flex flex-wrap gap-2">
                      {renderAcceptedStatuses(acceptedStatuses).map((status, index) => (
                        <Badge key={index} variant="secondary" className="bg-gray-200">
                          {status}
                        </Badge>
                      ))}
                    </div>
                  </div>
                  <div className="mb-2 pt-2">
                    <h3 className="font-semibold mb-2">Requires Visa Sponsorship:{" "}
                      <span className="font-normal text-sm">{booleanToYesOrNo(requiresSponsorship)}</span>
                    </h3>
                    <h3 className="font-semibold mb-2">Requires Security Clearance:{" "}
                      <span className="font-normal text-sm">{booleanToYesOrNo(requiresSecurityClearance)}</span>
                    </h3>
                    <h3 className="font-semibold mb-2">Requires Citizenship for Clearance:{" "}
                      <span className="font-normal text-sm">{booleanToYesOrNo(requiresCitizenshipForClearance)}</span>
                    </h3>
                  </div>
                </CardContent>
              </Card>
            </div>   
          </div>
          
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Problem Spaces</CardTitle>
            </CardHeader>
            <CardContent>
              {problemSpaces.map((space, index) => (
                <div key={index} className="mb-4">
                  <div className="flex justify-between mb-1">
                    <span>{space.category}</span>
                    <span>{(space.weight * 100).toFixed(2)}%</span>
                  </div>
                  <Progress value={space.weight * 100} 
                    className='[&>*]:bg-gray-700 h-3'
                    max={100} />
                </div>
              ))}
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Qualifications</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="mb-4">
                <h3 className="font-semibold mb-2">Must Have</h3>
                <ul className="list-disc pl-5">
                  {mustHave.map((qual, index) => (
                    <li key={index}>{qual}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Nice to Have</h3>
                {niceToHave.map((qual, index) => (
                  <div key={index} className="mb-4">
                    <div className="flex justify-between mb-1">
                      <span>{qual.qualification}</span>
                      <span>{(qual.weight * 100).toFixed(2)}%</span>
                    </div>
                    <Progress value={qual.weight * 100}
                      className='[&>*]:bg-gray-700 h-3'
                      max={100}  />
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
      {/* <div className="flex justify-end">
            <Button 
              type="submit"
              className="bg-mint100 text-black hover:bg-teal100">
                Save changes
            </Button>
          </div> */}
        </div>
      </form>
    </Form>
  );
};

export default CampaignDetails;
